<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="t('offlineTitle')"
      [showCloseButton]="false"
      [closeOnBackdropClick]="false"
      [critical]="true"
      [ariaLabelledBy]="'offline-screen-title'"
    >
      <div modal-content>
        <div id="offline-screen-icon" class="pb-4 flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12 text-ld-neutral-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0"
            />
            <line x1="1" y1="1" x2="23" y2="23" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="12" cy="18" r="1" fill="currentColor" stroke="none" />
          </svg>
        </div>

        <p id="offline-screen-message" class="text-ld-neutral-600 text-center">
          {{ t('offlineMessage') }}
        </p>
      </div>

      <div modal-footer class="flex flex-col gap-3">
        <button
          id="offline-screen-retry-button"
          type="button"
          class="btn-primary-ld-purple w-full"
          [disabled]="isRetrying()"
          (click)="onRetry()"
        >
          @if (isRetrying()) {
            {{ t('offlineRetrying') }}
          } @else {
            {{ t('offlineTryAgain') }}
          }
        </button>
        <button id="offline-screen-dismiss-button" type="button" class="btn-secondary w-full" (click)="onDismiss()">
          {{ t('offlineDismiss') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
